/* Pequeños Mundialistas — comportamientos de la landing y el carrito */
(function () {
  "use strict";

  var SPOTS_KEY = "pm_spots_left";
  var CD_KEY = "pm_cd_end";

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* modo incógnito restrictivo: seguimos sin persistencia */
    }
  }

  /* ---------- Video VSL: autoplay silenciado → clic para activar sonido ---------- */
  function initVideos() {
    document.querySelectorAll("[data-pm-video]").forEach(function (wrap) {
      var btn = wrap.querySelector("[data-pm-unmute]");
      var iframe = wrap.querySelector("[data-pm-video-iframe]");
      var base = wrap.getAttribute("data-video-base");
      if (!btn || !iframe || !base) return;
      btn.addEventListener("click", function () {
        iframe.src = base + "?autoplay=true&loop=false&muted=false&preload=true&responsive=true";
        btn.remove();
      });
    });
  }

  /* ---------- Botones de compra: agregan el producto del funnel y van a /cart ----------
     "Reseteo de funnel": el carrito queda SOLO con productos de este funnel
     (el principal + sus bumps, definidos en data-funnel-variants). Cualquier
     producto de otro funnel se quita. El href funciona como respaldo sin JS. */
  /* "Reseteo de funnel": deja el carrito SOLO con productos de este funnel
     (principal + bumps de data-funnel-variants) y agrega el principal. */
  function resetFunnelCart(btn) {
    var variantId = btn.getAttribute("data-variant-id");
    var allowed = (btn.getAttribute("data-funnel-variants") || variantId).split(",");
    return fetch("/cart.js")
      .then(function (r) { if (!r.ok) throw new Error("cart read failed"); return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) {
          if (allowed.indexOf(String(item.variant_id)) === -1) updates[item.variant_id] = 0;
        });
        updates[variantId] = 1;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates }),
        });
      })
      .then(function (r) { if (!r.ok) throw new Error("cart update failed"); return r; });
  }

  function initBuyButtons() {
    /* Delegado en document: sobrevive a re-renders de secciones */
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-pm-buy]");
      if (!btn) return;
      var variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;
      e.preventDefault();

      function proceed(mode) {
        // POPUP: se abre AL INSTANTE; el carrito se limpia/sincroniza en segundo plano.
        if (mode === "popup" && openCartPopup()) {
          resetFunnelCart(btn).then(function () { syncCartPopup(); }).catch(function () {});
          return;
        }
        // PÁGINA: resetea y va a /cart (con respaldo al href si falla).
        btn.style.opacity = "0.7";
        btn.style.pointerEvents = "none";
        resetFunnelCart(btn)
          .then(function () { window.location.href = "/cart"; })
          .catch(function () { window.location.href = btn.href; });
      }

      var pid = btn.getAttribute("data-product-id");
      var fh = btn.getAttribute("data-funnel-handle");
      if (funnelCfg) {
        proceed(checkoutModeFor(pid, fh)); // config ya cargada → decisión instantánea
      } else {
        // aún sin config: la esperamos (caso raro; prefetch en init suele evitarlo)
        loadFunnelConfig().then(function () { proceed(checkoutModeFor(pid, fh)); });
      }
    });
  }

  /* ---------- Config de funnels (Pixel + modo de checkout) ----------
     Se lee una vez del endpoint público funnel-pixel y se cachea. Si falla,
     el modo cae a 'page' (comportamiento de siempre: ir a /cart). */
  var FUNNEL_CFG_URL = "https://uooelivzplrzhsdzppzs.supabase.co/functions/v1/funnel-pixel";
  var funnelCfg = null;
  var funnelCfgPromise = null;
  function loadFunnelConfig() {
    if (funnelCfg) return Promise.resolve(funnelCfg);
    if (funnelCfgPromise) return funnelCfgPromise;
    funnelCfgPromise = fetch(FUNNEL_CFG_URL)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cfg) { funnelCfg = (cfg && cfg.funnels) || []; return funnelCfg; })
      .catch(function () { funnelCfg = []; return funnelCfg; });
    return funnelCfgPromise;
  }
  function checkoutModeFor(productId, funnelHandle) {
    var fs = funnelCfg || [];
    var pid = String(productId || "");
    var f = null;
    if (pid) f = fs.filter(function (x) { return (x.productIds || []).indexOf(pid) >= 0; })[0];
    if (!f && funnelHandle) f = fs.filter(function (x) { return x.funnelHandle === funnelHandle; })[0];
    return (f && f.checkoutMode) || "page";
  }

  /* ---------- Popup de carrito / order bump ----------
     El popup (sección pm-cart-popup) ya está en el DOM, oculto. Aquí lo
     mostramos al instante, sincronizamos su estado con el carrito real y
     manejamos los toggles de bumps (añadir/quitar). No se cierra con X: solo
     "Finalizar compra" lleva al checkout. */
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || "USD" }).format((cents || 0) / 100);
    } catch (e) {
      return "$" + ((cents || 0) / 100).toFixed(2);
    }
  }

  function openCartPopup() {
    var root = document.getElementById("pm-popup-root");
    if (!root) return false;
    root.hidden = false;
    document.body.classList.add("pm-popup-open");
    void root.offsetWidth; // reflow para que la animación corra
    root.classList.add("is-open");
    return true;
  }

  function syncCartPopup() {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) { updatePopupState(cart); })
      .catch(function () {});
  }

  function updatePopupState(cart) {
    var root = document.getElementById("pm-popup-root");
    if (!root || !cart) return;
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[String(it.variant_id)] = true; });

    var addedBox = root.querySelector("[data-pm-popup-added]");
    var listBox = root.querySelector("[data-pm-popup-list]");
    root.querySelectorAll("[data-pm-popup-row]").forEach(function (row) {
      var box = row.querySelector("[data-pm-popup-bump]");
      if (!box) return;
      var checked = !!inCart[box.getAttribute("data-variant-id")];
      box.checked = checked;
      box.disabled = false;
      row.classList.toggle("is-added", checked);
      row.classList.toggle("is-compact", checked);
      var cta = row.querySelector(".pm-popup-row-cta");
      if (cta) cta.textContent = checked ? "✓ Quitar" : "Añadir";
      // Lo añadido SUBE (debajo del producto principal, compacto, sin descripción);
      // lo no añadido va a la lista de ofertas (con todo visible).
      var target = checked ? addedBox : listBox;
      if (target && row.parentNode !== target) target.appendChild(row);
    });
    if (addedBox) addedBox.hidden = !addedBox.children.length;

    var totalEl = root.querySelector("[data-pm-popup-total]");
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price, cart.currency);

    var disc = root.querySelector("[data-pm-popup-discount]");
    if (disc) {
      if (cart.total_discount > 0) {
        disc.hidden = false;
        var amt = disc.querySelector("[data-pm-popup-discount-amt]");
        if (amt) amt.textContent = "−" + formatMoney(cart.total_discount, cart.currency);
      } else {
        disc.hidden = true;
      }
    }

    updatePopupProgress(cart.item_count || 0);
  }

  function updatePopupProgress(itemCount) {
    var bar = document.querySelector("[data-pm-popup-progress]");
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute("data-threshold"), 10) || 4;
    var percent = parseInt(bar.getAttribute("data-percent"), 10) || 20;
    var missing = threshold - itemCount;
    bar.querySelectorAll("[data-seg]").forEach(function (s, i) {
      s.classList.toggle("is-on", i + 1 <= itemCount);
      s.classList.toggle("is-done", missing <= 0);
    });
    var msg = document.querySelector("[data-pm-popup-progress-msg]");
    if (msg) {
      if (missing <= 0) {
        msg.innerHTML = "🎉 ¡Desbloqueaste el <strong>" + percent + "% de descuento</strong> en todo tu pedido!";
      } else if (missing === 1) {
        msg.innerHTML = "⚡ ¡Solo te falta <strong>1 producto</strong> para tu <strong>" + percent + "% de descuento</strong>!";
      } else {
        msg.innerHTML = "🔥 Agrega <strong>" + missing + " productos más</strong> y recibe el <strong>" + percent + "% de descuento</strong> extra en toda tu compra.";
      }
    }
  }

  function initCartPopup() {
    /* Toggle de un order bump dentro del popup */
    document.addEventListener("change", function (e) {
      var box = e.target.closest && e.target.closest("[data-pm-popup-bump]");
      if (!box) return;
      var variantId = Number(box.getAttribute("data-variant-id"));
      if (!variantId) return;
      var add = box.checked;
      // Feedback INSTANTÁNEO (óptimista): color + texto cambian ya; el total y la
      // posición se ajustan cuando responde el servidor (un solo viaje).
      var row = box.closest("[data-pm-popup-row]");
      function paint(state) {
        if (!row) return;
        row.classList.toggle("is-added", state);
        var c = row.querySelector(".pm-popup-row-cta");
        if (c) c.textContent = state ? "✓ Quitar" : "Añadir";
      }
      paint(add);
      box.disabled = true;
      // Un solo request: /cart/update.js devuelve el carrito completo (con total y descuento).
      var u = {}; u[variantId] = add ? 1 : 0;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: u }),
      })
        .then(function (r) { if (!r.ok) throw new Error("cart op failed"); return r.json(); })
        .then(function (cart) { updatePopupState(cart); })
        .catch(function () {
          box.checked = !add;
          paint(!add);
          box.disabled = false;
        });
    });

    /* Finalizar compra → checkout */
    document.addEventListener("click", function (e) {
      var go = e.target.closest && e.target.closest("[data-pm-popup-checkout]");
      if (!go) return;
      e.preventDefault();
      go.style.opacity = "0.7";
      go.style.pointerEvents = "none";
      window.location.href = "/checkout";
    });
  }

  /* ---------- Carrito: re-render parcial vía Section Rendering API ---------- */
  function refreshCartSection() {
    return fetch("/cart?sections=pm-cart")
      .then(function (r) {
        if (!r.ok) throw new Error("section render failed");
        return r.json();
      })
      .then(function (data) {
        var html = data["pm-cart"];
        var current = document.getElementById("shopify-section-pm-cart");
        if (!html || !current) throw new Error("no section");
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.getElementById("shopify-section-pm-cart");
        if (!fresh) throw new Error("no fresh section");
        current.innerHTML = fresh.innerHTML;
        normalizeQuantities();
        initCountdowns();
      });
  }

  /* Productos digitales: máximo 1 unidad por producto. Si por cualquier vía
     una línea queda con cantidad > 1, se corrige sola. */
  var normalizing = false;
  function normalizeQuantities() {
    if (normalizing) return;
    var updates = {};
    var found = false;
    document.querySelectorAll("[data-pm-line]").forEach(function (line) {
      var qty = parseInt(line.getAttribute("data-qty"), 10) || 1;
      if (qty > 1) {
        updates[line.getAttribute("data-variant-id")] = 1;
        found = true;
      }
    });
    if (!found) return;
    normalizing = true;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("normalize failed");
        return refreshCartSection();
      })
      .catch(function () {})
      .then(function () {
        normalizing = false;
      });
  }

  /* Order bumps y eliminación de items: delegados en document para sobrevivir
     a los re-renders de la sección del carrito. */
  function initCartDelegates() {
    document.addEventListener("change", function (e) {
      var box = e.target.closest && e.target.closest("[data-pm-bump]");
      if (!box || !box.checked) return;
      box.disabled = true;
      var label = box.closest("label");
      var text = document.querySelector("[data-pm-bump-label]");
      if (label) {
        label.style.opacity = "0.6";
        label.style.pointerEvents = "none";
        text = label.querySelector("[data-pm-bump-label]") || text;
      }
      if (text) text.textContent = "Agregando a tu pedido…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(box.getAttribute("data-variant-id")), quantity: 1 }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return refreshCartSection();
        })
        .catch(function () {
          box.checked = false;
          box.disabled = false;
          if (label) {
            label.style.opacity = "";
            label.style.pointerEvents = "";
          }
          if (text) text.textContent = "Sí, agregar a mi pedido";
        });
    });

    document.addEventListener("click", function (e) {
      var link = e.target.closest && e.target.closest("[data-pm-remove]");
      if (!link) return;
      e.preventDefault();
      link.style.opacity = "0.5";
      link.style.pointerEvents = "none";
      var updates = {};
      updates[link.getAttribute("data-variant-id")] = 0;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("remove failed");
          return refreshCartSection();
        })
        .catch(function () {
          window.location.href = link.href;
        });
    });
  }

  /* ---------- Acordeón FAQ ---------- */
  function initFaq() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll("[data-pm-faq]"));
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var answer = btn.parentElement.querySelector("[data-pm-faq-answer]");
        var sign = btn.querySelector("[data-pm-faq-sign]");
        var isOpen = !answer.hidden;
        buttons.forEach(function (other) {
          var a = other.parentElement.querySelector("[data-pm-faq-answer]");
          var s = other.querySelector("[data-pm-faq-sign]");
          a.hidden = true;
          if (s) s.textContent = "+";
          other.setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          answer.hidden = false;
          if (sign) sign.textContent = "−";
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  /* ---------- Count-up animado al entrar en pantalla ---------- */
  function initCountUps() {
    var els = document.querySelectorAll("[data-pm-countup]");
    if (!els.length) return;
    var animate = function (el) {
      var to = parseInt(el.getAttribute("data-to"), 10) || 0;
      var duration = 1100;
      var start = 0;
      var step = function (t) {
        if (!start) start = t;
        var p = Math.min((t - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * to);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = to;
      };
      requestAnimationFrame(step);
    };
    if (typeof IntersectionObserver === "undefined") {
      els.forEach(function (el) {
        el.textContent = el.getAttribute("data-to");
      });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    els.forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ---------- Countdown global persistente ----------
     Un único deadline compartido (localStorage) alimenta todos los contadores
     de todas las páginas: el carrito continúa el tiempo de la landing.
     Al llegar a cero, vuelve a empezar (loop). */
  function initCountdowns() {
    var boxes = document.querySelectorAll("[data-pm-countdown]");
    if (!boxes.length) return;
    if (initCountdowns._t) { clearInterval(initCountdowns._t); initCountdowns._t = null; }
    var minutes = parseInt(boxes[0].getAttribute("data-minutes"), 10) || 15;
    var totalMs = minutes * 60 * 1000;

    var end = parseInt(storageGet(CD_KEY), 10);
    var now = Date.now();
    if (!end || end <= now || end > now + totalMs) {
      end = now + totalMs;
      storageSet(CD_KEY, String(end));
    }

    var render = function () {
      var remaining = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (remaining === 0) {
        end = Date.now() + totalMs;
        storageSet(CD_KEY, String(end));
        remaining = minutes * 60;
      }
      var mm = String(Math.floor(remaining / 60)).padStart(2, "0");
      var ss = String(remaining % 60).padStart(2, "0");
      boxes.forEach(function (box) {
        var minEl = box.querySelector("[data-pm-cd-min]");
        var secEl = box.querySelector("[data-pm-cd-sec]");
        if (minEl) minEl.textContent = mm;
        if (secEl) secEl.textContent = ss;
      });
    };
    render();
    initCountdowns._t = setInterval(render, 1000);
  }

  /* ---------- Reveal on scroll (filas de bonos) ---------- */
  function initReveals() {
    var els = document.querySelectorAll(".pm-reveal");
    if (!els.length) return;
    if (typeof IntersectionObserver === "undefined") {
      els.forEach(function (el) {
        el.classList.add("pm-revealed");
      });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("pm-revealed");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    els.forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ---------- FOMO de compras + cupos restantes (persistentes) ---------- */
  function updateSpotsDisplays(n) {
    document.querySelectorAll("[data-pm-spots]").forEach(function (el) {
      el.textContent = n;
    });
  }

  function initFomo() {
    var configEl = document.querySelector("[data-pm-fomo-config]");
    var templateEl = document.querySelector("[data-pm-fomo-template]");
    if (!configEl || !templateEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    var buyers = config.buyers || [];
    if (!buyers.length) return;

    var totalSpots = config.totalSpots || 20;
    var spotsLeftStart = config.spotsLeftStart || 12;

    // Cupos compartidos entre páginas: el carrito muestra lo mismo que la landing.
    var stored = parseInt(storageGet(SPOTS_KEY), 10);
    var spotsLeft = stored >= 2 && stored <= spotsLeftStart ? stored : spotsLeftStart;
    updateSpotsDisplays(spotsLeft);

    var idx = 0;
    var scrollP = 0;
    var toastEl = null;
    var hideTimer = null;

    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      scrollP = max > 0 ? Math.min(1, window.scrollY / max) : 0;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    var showToast = function (buyer) {
      if (toastEl) toastEl.remove();
      var frag = templateEl.content.cloneNode(true);
      toastEl = frag.firstElementChild;
      toastEl.querySelector("[data-pm-fomo-avatar]").src = buyer.avatar;
      toastEl.querySelector("[data-pm-fomo-avatar]").alt = buyer.name;
      toastEl.querySelector("[data-pm-fomo-flag]").textContent = buyer.flag;
      toastEl.querySelector("[data-pm-fomo-name]").textContent = buyer.name;
      toastEl.querySelector("[data-pm-fomo-country]").textContent = buyer.country;
      document.body.appendChild(toastEl);
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        if (toastEl) {
          toastEl.remove();
          toastEl = null;
        }
      }, 5500);
    };

    var fire = function () {
      var buyer = buyers[idx % buyers.length];
      idx += 1;
      spotsLeft = Math.max(2, spotsLeft - 1);
      storageSet(SPOTS_KEY, String(spotsLeft));
      updateSpotsDisplays(spotsLeft);
      showToast(buyer);
      var base = 28000;
      var min = 8000;
      var delay = Math.max(min, base - scrollP * (base - min));
      setTimeout(fire, delay + 1500);
    };

    setTimeout(fire, 30000); // primer FOMO a los 30 segundos
  }

  /* ---------- Flipbook (vista previa del ebook) ---------- */
  function initFlipbook() {
    var container = document.querySelector("[data-pm-flipbook]");
    var wrap = document.querySelector("[data-pm-flipbook-wrap]");
    if (!container || typeof St === "undefined" || !St.PageFlip) return;

    var pages = container.querySelectorAll(".pm-flip-page");
    if (!pages.length) return;

    var pageFlip = new St.PageFlip(container, {
      width: 420,
      height: 560,
      size: "stretch",
      minWidth: 250,
      maxWidth: 520,
      minHeight: 330,
      maxHeight: 700,
      maxShadowOpacity: 0.45,
      showCover: false,
      mobileScrollSupport: true,
      drawShadow: true,
      flippingTime: 750,
      startPage: 0,
      usePortrait: true,
      autoSize: true,
      clickEventForward: true,
      useMouseEvents: true,
      swipeDistance: 30,
      showPageCorners: true,
      disableFlipByClick: false,
    });
    pageFlip.loadFromHTML(pages);

    if (typeof IntersectionObserver === "undefined" || !wrap) return;
    var started = false;
    var obs = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting || started) return;
        started = true;
        obs.disconnect();
        var prev = -1;
        var interval = setInterval(function () {
          var cur = pageFlip.getCurrentPageIndex();
          if (cur === prev) {
            clearInterval(interval);
            return;
          }
          prev = cur;
          pageFlip.flipNext();
        }, 2000);
      },
      { threshold: 0.25 }
    );
    obs.observe(wrap);
  }

  /* ---------- Contador del carrito (encabezado de tienda) ---------- */
  function initCartCount() {
    var els = document.querySelectorAll("[data-pm-cart-count]");
    if (!els.length) return;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        els.forEach(function (el) {
          el.textContent = n;
          if (n > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
        });
      })
      .catch(function () {});
  }

  /* ---------- Agregar al carrito SIN salir de la página (AJAX) ----------
     Botones con [data-pm-add]. "Comprar ahora" NO usa esto (ese sí va al pago).
     Sin JS, el botón sigue funcionando como envío de formulario (respaldo). */
  function initAddToCart() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-pm-add]");
      if (!btn) return;
      e.preventDefault();
      var vid = Number(btn.getAttribute("data-variant-id"));
      if (!vid || btn.dataset.busy) return;
      btn.dataset.busy = "1";
      var orig = btn.innerHTML;
      var okLabel = btn.getAttribute("data-added") || "✓";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: vid, quantity: 1 }),
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () {
          btn.innerHTML = okLabel;
          initCartCount();
          setTimeout(function () { btn.innerHTML = orig; delete btn.dataset.busy; }, 1400);
        })
        .catch(function () { btn.innerHTML = orig; delete btn.dataset.busy; });
    });
  }

  function init() {
    initVideos();
    initBuyButtons();
    loadFunnelConfig();
    initCartPopup();
    initCartCount();
    initAddToCart();
    initCartDelegates();
    normalizeQuantities();
    initFaq();
    initCountUps();
    initCountdowns();
    initReveals();
    initFomo();
    initFlipbook();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
